<template>
  <StudioMultiSelect
    v-model="channelsSelected"
    :searchable="true"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label + ' Listening')"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === 0"
        class="grey--text caption"
      >
        {{ channelsSelected.length }} {{ filterMessage(channelsSelected) }}
      </span>
    </template>
  </StudioMultiSelect>
</template>

<script>
import channelModel from '@/mixins/channel-model';
import filtersModel from '@/mixins/filters-model';
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import { DATA_TYPE } from '@/store/modules/cards/constants';

export default {
  name: 'ChannelFilter',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    channelModel,
    filtersModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isBigFour: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    dataType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      label: 'Canais',
      placeholder: 'Todos',
    };
  },
  computed: {
    channelsSelected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        let newChannels = newValue;

        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        if (newValue && newValue.length && typeof (newValue[0]) === 'object') {
          newChannels = newValue.map(v => v && v.value);
        }

        this.$emit('input', {
          value: newChannels,
        });
      },
    },
    selectItemsValue() {
      return this.selectItems.map(v => v.value);
    },
    selectItems() {
      const channelToSelectObject = (channel) => {
        const channelObj = this.getChannelObj(channel);
        return {
          text: channelObj.name,
          value: channel,
        };
      };

      if (this.isBigFour) {
        return this.fourBigChannels.map(channelToSelectObject);
      }

      const channelsMapped = this.channels.map(channelToSelectObject);

      if (this.dataType === DATA_TYPE.LISTENING) {
        const channelsList = channelsMapped.filter(object => {
          return object.value !== 'tiktok';
        });
        return channelsList;
      }

      return channelsMapped;
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
